import { render, staticRenderFns } from "./PrincipalRegisterDialog.vue?vue&type=template&id=134e0cb4"
import script from "./PrincipalRegisterDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalRegisterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports